import React from "react";

const CustomErrors = ({ Code, Description }) => {
  return (
    <div>
      <span key={Code.Code} className="required">
        {Description}
      </span>
      <br />
    </div>
  );
};

export default CustomErrors;
